export const STORAGE_PREFIX = "user-data-statistic-columns-v1-";

export const COLUMNS = [
  { prop: "uid", label: "UID", minWidth: 110 },
  { prop: "statisticsDate", label: "统计日期", minWidth: 200 },
  { prop: "userType", label: "用户类型", minWidth: 110 },
  { prop: "topPartnerUid", label: "顶级合伙人UID", minWidth: 140 },
  {
    prop: "chainDepositAmount",
    label: "链上充值金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "chainWithdrawAmount",
    label: "链上提现金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "chainNetDepositAmount",
    label: "链上净充值金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "internalTransferInAmount",
    label: "内部转入金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "internalTransferOutAmount",
    label: "内部转出金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "internalNetTransferInAmount",
    label: "内部净转入金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "userNetDepositAmount",
    label: "用户净入金金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "spotTradingVolume",
    label: "现货交易额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "spotFee",
    label: "现货手续费（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractTransferInAmount",
    label: "合约账户转入金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractTransferOutAmount",
    label: "合约账户转出金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractNetTransferInAmount",
    label: "合约账户净转入（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractTradingVolume",
    label: "合约交易额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractFee",
    label: "合约手续费（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "fundingFee",
    label: "资金费（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractClosedPnl",
    label: "合约平仓盈亏（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractNetPnl",
    label: "合约净盈亏（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "bonusFeeDeductAmount",
    label: "体验金抵扣手续费金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "bonusFundingDeductAmount",
    label: "体验金抵扣资金费金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "bonusPnlDeductAmount",
    label: "体验金抵扣盈亏金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "feeCouponDeductAmount",
    label: "手续费抵扣券抵扣金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "pnlCouponDeductAmount",
    label: "盈亏抵扣券抵扣金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractDeductFee",
    label: "合约扣减手续费（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractFeeAfterDeduct",
    label: "抵扣后合约手续费（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "contractNetPnlAfterDeduct",
    label: "抵扣后合约净盈亏（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "estimatedRebateAmount",
    label: "预计返佣金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "actualRebateAmount",
    label: "实际返佣金额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "positionCouponProfit",
    label: "仓位体验券获利（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "activityRewardAmount",
    label: "活动获得奖励（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "openingContractBalance",
    label: "期初合约账户余额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "openingBalance",
    label: "期初账户余额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "closingContractBalance",
    label: "期末合约账户余额（USDT）",
    minWidth: 200,
    type: "amount",
  },
  {
    prop: "closingBalance",
    label: "期末账户余额（USDT）",
    minWidth: 200,
    type: "amount",
  },
];

export const SUMMARY_FIELDS = [
  "contractFee",
  "fundingFee",
  "contractClosedPnl",
  "contractNetPnl",
  "bonusFeeDeductAmount",
  "bonusFundingDeductAmount",
  "bonusPnlDeductAmount",
  "feeCouponDeductAmount",
  "pnlCouponDeductAmount",
  "contractNetPnlAfterDeduct",
  "actualRebateAmount",
  { prop: "contractNetPnlAfterRebate", label: "返佣后合约净盈亏（USDT）", type: "amount" },
  "positionCouponProfit",
  "contractDeductFee",
].map((field) => typeof field === "string"
  ? COLUMNS.find((column) => column.prop === field)
  : field);
